const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: true,
  user: null,
};
export default function authReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case 'LOAD_USER':
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload,
      };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        ...payload,
        error: null,
        isAuthenticated: true,
        loading: false,
      };
    case 'LOGIN_FAILED':
      localStorage.removeItem('token');
      localStorage.removeItem('tokenGenerationTime');
      return {
        ...state,
        token: null,
        error: payload,
        isAuthenticated: false,
        loading: false,
      };
    case 'LOGOUT':
      localStorage.removeItem('token');
      localStorage.removeItem('tokenGenerationTime');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
      };
    default:
      return state;
  }
}
